// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-table-container {
  width: 100%;
  position: relative;
  top: 0vh;
}

.admin-orders-page-container {
  padding: 16px;
  width: 80vw;
  align-items: center;
  margin-top: 0;
}

.admin-table-heading {
  color: #ffffff;
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
}

.admin-table-search {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #f3f4f6;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.admin-search-control {
  display: flex;
  flex-direction: column;
}

.admin-search-label {
  font-size: 1.75rem;
  font-weight: bold;
  color: #247a97;
  text-align: center;
}

.admin-search-input {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 1.25rem;
  background-color: white;
}

.admin-table-wrapper {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow-x: auto;
}

.admin-orders-table {
  width: 100%;
  border-collapse: collapse;
}

.admin-orders-table thead {
  background-color: #e2e2e2;
  text-align: left;
}

.admin-orders-table thead th {
  font-size: 1.5rem;
  padding: 8px;
}

.admin-orders-table tbody td {
  font-size: 1.25rem;
  padding: 8px;
  text-align: left;
}

.admin-orders-table tr {
  border: 1px solid #ccc;
}

.admin-table-row td:last-child,
.admin-table-row th:last-child {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.admin-table-row {
  transition: background-color 0.3s;

  &:hover {
    background-color: #e2e2e2;
    transition: ease 0.3s;
    transform: scale(0.95);
  }
}

.admin-orders-table-header {
  color: #247a97;
}

.admin-table-cell-avatar img {
  border-radius: 50%;
  width: 48px;
  height: 48px;
}

.admin-table-cell-username {
  color: #333;
}

.admin-orders-table-action-button {
  padding: 8px 16px;
  background-color: #247a97;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;

  :hover {
    background-color: #22c55e;
  }
}

.admin-pagination {
  display: flex;
  justify-content: center;
  padding-top: 16px;
}

.admin-pagination .btn-sm {
  padding: 8px;
  font-size: 1rem;
  margin: 0 4px;
  border-radius: 4px;
}

.admin-pagination .btn-sm:hover {
  background-color: #e2e2e2;
}

.admin-modal {
  min-width: 300px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.admin-modal-header {
  font-size: 2rem;
  font-weight: bold;
  color: #247a97;
}

.admin-modal-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.admin-modal-content-section {
  display: flex;
  flex-direction: column;
}

.admin-modal-content-detail,
.admin-modal-content-details {
  font-size: 1.5rem;
  color: #333;
  margin-top: 0.5rem;
}

.admin-modal-content-details {
  text-align: center;
  color: #247a97;
  font-weight: bold;
}

.admin-modal-items {
  margin-top: 16px;
}

.admin-modal-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.admin-modal-item-avatar img {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 15px;
}

.admin-modal-item-name {
  margin-left: 8px;
  font-size: 1.25rem;
  color: #333;
}

.admin-modal-item-quantity {
  margin-left: auto;
  font-size: 1.25rem;
  color: #333;
}

/* New Styles for Delete Button */
.delete-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgb(20, 20, 20);
  border: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.164);
  cursor: pointer;
  transition-duration: 0.3s;
  overflow: hidden;
  position: relative;
}

.delete-svgIcon {
  width: 15px;
  transition-duration: 0.3s;
}

.delete-svgIcon path {
  fill: white;
}

.delete-button:hover {
  width: 90px;
  border-radius: 50px;
  transition-duration: 0.3s;
  background-color: rgb(255, 69, 69);
  align-items: center;
}

.delete-button:hover .delete-svgIcon {
  width: 20px;
  transition-duration: 0.3s;
  transform: translateY(60%);
  transform: rotate(360deg);
}

.delete-button::before {
  display: none;
  content: "Delete";
  color: white;
  transition-duration: 0.3s;
  font-size: 2px;
}

.delete-button:hover::before {
  display: block;
  padding-right: 10px;
  font-size: 13px;
  opacity: 1;
  transform: translateY(0px);
  transition-duration: 0.3s;
}

@media (max-width: 991px) {
  .admin-orders-page-container {
    width: 85vw;
  }

  /* Target the header of the orders table */
  .admin-orders-table thead th.admin-orders-table-header {
    background-color: #e2e2e2;
    font-size: 1.5rem;
    padding: 8px;
    text-align: left;
  }

  /* Target the username and other cells in the body of the table */
  .admin-orders-table tbody td.admin-orders-table-cell-username,
  .admin-orders-table tbody td.admin-orders-table-cell {
    font-size: 1.25rem;
  }

  /* Target the action cell specifically */
  .admin-orders-table tbody th.admin-orders-action-cell {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
    padding: 5px;
  }

  /* Target the total price cell */
  .admin-orders-table tbody td.admin-orders-total-price-cell {
    font-size: 1.75rem;
  }

  /* Target buttons in the action cell */
  .admin-orders-table
    tbody
    th.admin-orders-action-cell
    .admin-orders-table-action-button,
  .admin-orders-table
    tbody
    th.admin-orders-action-cell
    .delete-button:hover::before {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AdminOrdersPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,iCAAiC;;EAEjC;IACE,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;;EAEjC;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;EACb;;EAEA,0CAA0C;EAC1C;IACE,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;;EAEA,iEAAiE;EACjE;;IAEE,kBAAkB;EACpB;;EAEA,wCAAwC;EACxC;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,YAAY;EACd;;EAEA,gCAAgC;EAChC;IACE,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;;;;;;;;IAQE,iBAAiB;EACnB;AACF","sourcesContent":[".admin-table-container {\n  width: 100%;\n  position: relative;\n  top: 0vh;\n}\n\n.admin-orders-page-container {\n  padding: 16px;\n  width: 80vw;\n  align-items: center;\n  margin-top: 0;\n}\n\n.admin-table-heading {\n  color: #ffffff;\n  font-size: 1.75rem;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.admin-table-search {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  background-color: #f3f4f6;\n  padding: 8px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.admin-search-control {\n  display: flex;\n  flex-direction: column;\n}\n\n.admin-search-label {\n  font-size: 1.75rem;\n  font-weight: bold;\n  color: #247a97;\n  text-align: center;\n}\n\n.admin-search-input {\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 1.25rem;\n  background-color: white;\n}\n\n.admin-table-wrapper {\n  background-color: #ffffff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.admin-orders-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.admin-orders-table thead {\n  background-color: #e2e2e2;\n  text-align: left;\n}\n\n.admin-orders-table thead th {\n  font-size: 1.5rem;\n  padding: 8px;\n}\n\n.admin-orders-table tbody td {\n  font-size: 1.25rem;\n  padding: 8px;\n  text-align: left;\n}\n\n.admin-orders-table tr {\n  border: 1px solid #ccc;\n}\n\n.admin-table-row td:last-child,\n.admin-table-row th:last-child {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n}\n\n.admin-table-row {\n  transition: background-color 0.3s;\n\n  &:hover {\n    background-color: #e2e2e2;\n    transition: ease 0.3s;\n    transform: scale(0.95);\n  }\n}\n\n.admin-orders-table-header {\n  color: #247a97;\n}\n\n.admin-table-cell-avatar img {\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n}\n\n.admin-table-cell-username {\n  color: #333;\n}\n\n.admin-orders-table-action-button {\n  padding: 8px 16px;\n  background-color: #247a97;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n\n  :hover {\n    background-color: #22c55e;\n  }\n}\n\n.admin-pagination {\n  display: flex;\n  justify-content: center;\n  padding-top: 16px;\n}\n\n.admin-pagination .btn-sm {\n  padding: 8px;\n  font-size: 1rem;\n  margin: 0 4px;\n  border-radius: 4px;\n}\n\n.admin-pagination .btn-sm:hover {\n  background-color: #e2e2e2;\n}\n\n.admin-modal {\n  min-width: 300px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.admin-modal-header {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #247a97;\n}\n\n.admin-modal-content {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.admin-modal-content-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.admin-modal-content-detail,\n.admin-modal-content-details {\n  font-size: 1.5rem;\n  color: #333;\n  margin-top: 0.5rem;\n}\n\n.admin-modal-content-details {\n  text-align: center;\n  color: #247a97;\n  font-weight: bold;\n}\n\n.admin-modal-items {\n  margin-top: 16px;\n}\n\n.admin-modal-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.admin-modal-item-avatar img {\n  width: 3.5rem;\n  height: 3.5rem;\n  border-radius: 15px;\n}\n\n.admin-modal-item-name {\n  margin-left: 8px;\n  font-size: 1.25rem;\n  color: #333;\n}\n\n.admin-modal-item-quantity {\n  margin-left: auto;\n  font-size: 1.25rem;\n  color: #333;\n}\n\n/* New Styles for Delete Button */\n.delete-button {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: rgb(20, 20, 20);\n  border: none;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.164);\n  cursor: pointer;\n  transition-duration: 0.3s;\n  overflow: hidden;\n  position: relative;\n}\n\n.delete-svgIcon {\n  width: 15px;\n  transition-duration: 0.3s;\n}\n\n.delete-svgIcon path {\n  fill: white;\n}\n\n.delete-button:hover {\n  width: 90px;\n  border-radius: 50px;\n  transition-duration: 0.3s;\n  background-color: rgb(255, 69, 69);\n  align-items: center;\n}\n\n.delete-button:hover .delete-svgIcon {\n  width: 20px;\n  transition-duration: 0.3s;\n  transform: translateY(60%);\n  transform: rotate(360deg);\n}\n\n.delete-button::before {\n  display: none;\n  content: \"Delete\";\n  color: white;\n  transition-duration: 0.3s;\n  font-size: 2px;\n}\n\n.delete-button:hover::before {\n  display: block;\n  padding-right: 10px;\n  font-size: 13px;\n  opacity: 1;\n  transform: translateY(0px);\n  transition-duration: 0.3s;\n}\n\n@media (max-width: 991px) {\n  .admin-orders-page-container {\n    width: 85vw;\n  }\n\n  /* Target the header of the orders table */\n  .admin-orders-table thead th.admin-orders-table-header {\n    background-color: #e2e2e2;\n    font-size: 1.5rem;\n    padding: 8px;\n    text-align: left;\n  }\n\n  /* Target the username and other cells in the body of the table */\n  .admin-orders-table tbody td.admin-orders-table-cell-username,\n  .admin-orders-table tbody td.admin-orders-table-cell {\n    font-size: 1.25rem;\n  }\n\n  /* Target the action cell specifically */\n  .admin-orders-table tbody th.admin-orders-action-cell {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    align-items: flex-start;\n    padding: 5px;\n  }\n\n  /* Target the total price cell */\n  .admin-orders-table tbody td.admin-orders-total-price-cell {\n    font-size: 1.75rem;\n  }\n\n  /* Target buttons in the action cell */\n  .admin-orders-table\n    tbody\n    th.admin-orders-action-cell\n    .admin-orders-table-action-button,\n  .admin-orders-table\n    tbody\n    th.admin-orders-action-cell\n    .delete-button:hover::before {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
